export const countDecimals = (value) => {

    if (
        isNaN(value)
        || Math.floor(value) === value
    ) {

        return 0;

    }

    return value.toString().split(".")[1].length;

};

export const round = (value, toNearest) => {

    const fixed = countDecimals(toNearest);

    return parseFloat((Math.round(value / toNearest) * toNearest).toFixed(fixed));

};

export const closest = (num, arr, lower) => {

    let mid;
    let lo = 0;
    let hi = arr.length - 1;

    while (hi - lo > 1) {

        mid = Math.floor((lo + hi) / 2);

        if (arr[mid] < num) {

            lo = mid;

        } else {

            hi = mid;

        }

    }

    if (
        lower
        && num - arr[lo] <= arr[hi] - num
    ) {

        return arr[lo];

    }

    return arr[hi];

};

export const sortByVal = (a, b) => {

    if (a.val > b.val) {

        return 1;

    }

    if (b.val > a.val) {

        return -1;

    }

    return 0;

};

export const getUpdatedHandles = (
    handles,
    updateKey,
    updateValue
) => {

    const index = handles.findIndex(v => v.key === updateKey);

    if (index !== -1) {

        const { key, val } = handles[index];

        if (val === updateValue) {

            return handles;

        }

        return [
            ...handles.slice(0, index),
            {
                key,
                val: updateValue,
            },
            ...handles.slice(index + 1),
        ].sort(sortByVal);

    }

    return handles;

};

export const playheadMode = (curr, next, min, max) => {

    const nextVal = next[0].val;

    if (nextVal < min || nextVal > max) {

        return curr;

    }

    return next;

};

export const segmentedMode = (curr, next, segments, getRoundedSegment) => {

    let indexForMovingHandle = -1;
    let handleMoveIsPositive = true;

    // Prevent crossing and determine handle and direction of movement
    for (let i = 0; i < curr.length; i++) {

        if (next[i].val !== curr[i].val) {

            indexForMovingHandle = i;
            handleMoveIsPositive = next[i].val - curr[i].val > 0;

        }

        if (curr[i].key !== next[i].key) {

            return curr;

        }
        if (next[i + 1] && next[i].val === next[i + 1].val) {

            return curr;

        }

    }

    // nothing has changed (shouldn't happen but just in case).
    if (indexForMovingHandle === -1) {

        return curr;

    }

    const startHandleIndex = 0;
    const endHandleIndex = 1;
    const nextStartSegmentIndex = segments.indexOf(next[startHandleIndex].val);
    const nextEndSegmentIndex = segments.indexOf(next[endHandleIndex].val);

    // Return next if value is a segment
    if (
        nextStartSegmentIndex !== -1
        && nextEndSegmentIndex !== -1
    ) {

        return next;

    }

    // If value is past following segment -> return updated value with closest valid segment
    const indexForStillHandle = indexForMovingHandle === startHandleIndex ? endHandleIndex : startHandleIndex;
    const nextVal = next[indexForMovingHandle].val;
    const nextSegment = closest(nextVal, segments, handleMoveIsPositive);
    const stillHandleVal = getRoundedSegment(curr[indexForStillHandle].val);

    if (
        indexForMovingHandle === startHandleIndex && nextSegment < stillHandleVal
        || indexForMovingHandle === endHandleIndex && nextSegment > stillHandleVal
    ) {

        return getUpdatedHandles(
            curr,
            curr[indexForMovingHandle].key,
            nextSegment
        );

    }

    return curr;

};
